import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  supplierBreadcrumb: {
    defaultMessage: 'Suppliers',
    id: 'YYf76V',
    description: 'Suppliers page header',
  },
  supplier: {
    defaultMessage: '>> {supplierName}',
    id: 'SGubsI',
    description: 'Supplier name breadcrumb',
  },
});
